export function composeImageUrl(imageUrl: string): string {
  const config = useRuntimeConfig();

  return `${config.public.metApiBaseUrl}${imageUrl}`;
}
